import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import LogInComponent from '../LogInComponent/LogInComponent';

class LoginPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            currentPage: this.props.currentPage,
            error: '',
            errorTitle: ''
        };
        this.handleError = this.handleError.bind(this);
    }

    handleError(error, errorTitle) {
        this.setState({error, errorTitle});
    }

    render() {
        let options = {'siteName': this.props.siteName};
        let cardContent = (
            <LogInComponent
                actionLocation={this.props.actionLocation}
                lingua={this.props.lingua}
                emailAddress={this.props.emailAddress}
                service={this.props.service}
                handleError={this.handleError}
                onClose={this.props.onClose}
                updatePage={this.props.updatePage}
                passwordType = {this.props.passwordType}
                showHidePassword={this.props.showHidePassword}
                isWaiting={this.props.isWaiting}
                enableLoading={this.props.enableLoading}
                disableLoading={this.props.disableLoading}
                setAuthJson={this.props.setAuthJson}
                useNewEndpoints={this.props.useNewEndpoints}
                multiUserEnabled={this.props.multiUserEnabled}
            />
        );
        return (
            <div className="LoginPageComponent border-border-color">
                <HeaderSectionComponent header={this.props.lingua.read('lex.header.initial', options)}/>
                <CalloutCardComponent content={cardContent} error={this.state.error} errorTitle={this.state.errorTitle}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </div>
        );
    }
}

export default LoginPageComponent;
